import {
    CREATE_REQUEST_FORM_FAILURE,
    CREATE_REQUEST_FORM_REQUEST,
    CREATE_REQUEST_FORM_SUCCESS,
    CREATE_USER_FORM_REQUEST_FORM,
    FETCH_REQUEST_FORM_FAILURE,
    FETCH_REQUEST_FORM_REQUEST,
    FETCH_REQUEST_FORM_SUCCESS,
    FETCH_SINGLE_REQUEST_FORM_FAILURE,
    FETCH_SINGLE_REQUEST_FORM_REQUEST,
    FETCH_SINGLE_REQUEST_FORM_SUCCESS,
    REQUEST_FORM_USERFORM_RESET,
    UPDATE_REQUEST_FORM_REQUEST,
    UPDATE_REQUEST_FORM_SUCCESS,
    UPDATE_REQUEST_FORM_FAILURE,
    DELETE_REQUEST_FORM_REQUEST,
    DELETE_REQUEST_FORM_SUCCESS,
    DELETE_REQUEST_FORM_FAILURE,
    RESET_CODE,
    FETCH_MULTIPLE_REQUEST_FORM_FAILURE,
    FETCH_MULTIPLE_REQUEST_FORM_REQUEST,
    FETCH_MULTIPLE_REQUEST_FORM_SUCCESS,
} from './requestForm.ationsType';

export const REQUEST_FORM = 'requestForm';

let initialState = {
    loading: false,
    requestForm: [],
    requestFormprint: [],
    requestFormMultipleprint: [],
    // userform: {},
    userform: {
        fldRequestNo: 'Auto Generated',
        fldRequestDt: new Date().toISOString().split("T")[0]
    },
    selectedYear: {},
    errorMessage: '',
    iperrorMessage: '',
    generatedCode: '',
    generatedMultiCode: ''
};

export let requestFormReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;
    switch (type) {
        case FETCH_REQUEST_FORM_REQUEST:
        case CREATE_REQUEST_FORM_REQUEST:
        case FETCH_SINGLE_REQUEST_FORM_REQUEST:
        case UPDATE_REQUEST_FORM_REQUEST:
        case DELETE_REQUEST_FORM_REQUEST:
        case FETCH_MULTIPLE_REQUEST_FORM_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                requestForm: updatePayload
            };

        case CREATE_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                generatedCode: updatePayload,
                generatedMultiCode: updatePayload
            };

        case FETCH_SINGLE_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                requestFormprint: updatePayload
            };
        case FETCH_MULTIPLE_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                requestFormMultipleprint: updatePayload
            };
        case UPDATE_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedYear: {}
            };
        case DELETE_REQUEST_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedYear: {}
            };
        case RESET_CODE:
            return {
                ...state,
                loading: false,
                generatedCode: ''
            }
        case FETCH_REQUEST_FORM_FAILURE:
        case CREATE_REQUEST_FORM_FAILURE:
        case FETCH_SINGLE_REQUEST_FORM_FAILURE:
        case UPDATE_REQUEST_FORM_FAILURE:
        case DELETE_REQUEST_FORM_FAILURE:
        case FETCH_MULTIPLE_REQUEST_FORM_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_REQUEST_FORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case REQUEST_FORM_USERFORM_RESET:
            return {
                ...state,
                selectedYear: {},
            };
        default:
            return state;
    }
};
